/* sp-home.js: homepage behavior (menu, join box chips, accordions, announcement rotator, header state, sticky bar,
   pinned numerals, reveals). Port of 2026-10-02-hp-preview/hp.js; per-flavor values read from data-* attributes. */
(function(){
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function $(id){ return document.getElementById(id); }
  function all(sel){ return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  /* ---- mobile menu ---- */
  var mb = $("menu-btn"), mnav = $("mnav") || document.createElement("nav");
  function setMenu(open){ if (!mb) return; mb.setAttribute("aria-expanded", open ? "true" : "false"); mnav.classList.toggle("open", open); }
  if (mb) mb.addEventListener("click", function(){ setMenu(mb.getAttribute("aria-expanded") !== "true"); });
  all("#mnav a").forEach(function(a){ a.addEventListener("click", function(){ setMenu(false); }); });
  document.addEventListener("keydown", function(e){ if (e.key === "Escape" && mnav.classList.contains("open")){ setMenu(false); mb.focus(); } });

  /* ---- join box: a chip swaps the stage color + bag, the flavor name, the membership CTA (/pages/join?flavor=<name>#buy)
     and the one-time link (straight to cart). All per-flavor values come from the chip's data-* attributes (Liquid). ---- */
  var chips = all(".sph .chip");
  function pick(c){
    var f = c.getAttribute("data-name");
    chips.forEach(function(x){ x.setAttribute("aria-pressed", x === c ? "true" : "false"); });
    var jf = $("jflavor"), fl = $("jflag"), st = $("jstage"), im = $("jimg"), cta = $("jcta"), once = $("jonce");
    if (jf) jf.textContent = f;
    if (fl) fl.textContent = (fl.getAttribute("data-prefix") || "") + " " + f;
    if (st) st.style.setProperty("--gal", c.getAttribute("data-ground"));
    if (im){ im.setAttribute("srcset", c.getAttribute("data-bag-set")); im.setAttribute("src", c.getAttribute("data-bag-src"));
      im.alt = (im.getAttribute("data-alt-prefix") || "") + " " + f; }
    if (once) once.href = c.getAttribute("data-once");
    if (cta) cta.href = c.getAttribute("data-join");
  }
  chips.forEach(function(c){ c.addEventListener("click", function(){ pick(c); }); });

  /* ---- accordions ---- */
  all(".acc-btn").forEach(function(b){
    b.addEventListener("click", function(){
      var open = b.getAttribute("aria-expanded") === "true";
      b.setAttribute("aria-expanded", open ? "false" : "true");
      var pn = $(b.getAttribute("aria-controls")); if (pn) pn.classList.toggle("open", !open);
    });
  });

  /* ---- announcement rotator ---- */
  var ann = $("ann"), annP = ann ? ann.querySelectorAll("p") : [];
  if (!reduce && annP.length > 1) setInterval(function(){
    var alt = ann.classList.toggle("alt");
    annP[0].setAttribute("aria-hidden", alt ? "true" : "false");
    annP[1].setAttribute("aria-hidden", alt ? "false" : "true");
  }, 4000);

  /* ---- scroll pass: header, pinned numerals, sticky bar, reveals (rAF geometry check, same as /pages/join) ---- */
  var hdr = $("hdr") || document.createElement("div"), sbar = $("sbar") || document.createElement("div"),
      join = $("join"), hero = document.querySelector(".sph .hero");
  var ftr = document.querySelector(".sph .ftr");
  var ctas = all(".sph a.btn, .sph .tlink").filter(function(a){ return !sbar.contains(a) && !mnav.contains(a); });
  function padForBar(){ var h = sbar.offsetHeight; if (h) document.body.style.setProperty("--sbar-h", h + "px"); }
  padForBar(); window.addEventListener("resize", padForBar);
  var nums = $("nums"), numsLi = all("#nums-list li"), numsBag = $("nums-bag");
  var items = all(".sph .rv");
  if (reduce){ items.forEach(function(el){ el.classList.add("is-in"); }); items = []; numsLi.forEach(function(li){ li.classList.add("lit"); }); }
  var ticking = false;
  function pass(){
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var y = window.pageYOffset || document.documentElement.scrollTop;
    hdr.classList.toggle("is-scrolled", y > 80);

    var jr = join ? join.getBoundingClientRect() : null;
    var inJoin = !!jr && jr.top < vh * 0.6 && jr.bottom > vh * 0.4;
    var zone = vh - (sbar.offsetHeight || 110) - 8, covers = false;
    for (var c = 0; c < ctas.length && !covers; c++){
      var cr = ctas[c].getBoundingClientRect();
      if (cr.height && cr.bottom > zone && cr.top < vh) covers = true;
    }
    var ftrIn = ftr && ftr.getBoundingClientRect().top < vh;
    var pastHero = hero ? hero.getBoundingClientRect().bottom < 0 : true;
    sbar.classList.toggle("show", pastHero && !inJoin && !covers && !ftrIn && !mnav.classList.contains("open"));

    if (!reduce && nums && numsBag){
      var nr = nums.getBoundingClientRect();
      var span = Math.max(1, nr.height - vh);
      var p = Math.min(1, Math.max(0, -nr.top / span));
      numsLi.forEach(function(li, i){ li.classList.toggle("lit", p >= i * 0.22 + 0.04 || nr.bottom < vh); });
      numsBag.style.setProperty("--rise", (60 - 60 * Math.min(1, p * 1.4)).toFixed(1) + "%");
    }
    for (var i = items.length - 1; i >= 0; i--){
      var r = items[i].getBoundingClientRect();
      if (r.top < vh * 0.92){ items[i].classList.add("is-in"); items.splice(i, 1); }
    }
  }
  function onScroll(){ if (!ticking){ ticking = true; window.requestAnimationFrame(pass); } }
  window.addEventListener("scroll", onScroll, { passive:true });
  window.addEventListener("resize", onScroll);
  window.addEventListener("load", onScroll);
  pass();
})();

/* ---- 9-card email pop-up (DECISIONS-F F22; sp-home-giftpop). Opens after data-delay seconds or data-scroll % of the page,
   once per session (sessionStorage), never under ?nopop=1 and never on /pages/join. Shares the device-wide sp_gifts state
   with the /pages/join pop-up (done = never auto-open again; dismissed = not for 7 days). The cards stay locked (face-down) until a
   valid email is accepted by the Klaviyo client subscriptions API (list + email marketing consent SUBSCRIBED). Then any three
   picks reveal the three gifts in a fixed order; the other six stay face-down, dimmed and inert. "Show me" turns over exactly
   three. Focus-trapped; Esc / X / "Keep browsing" close. The page scroll is locked only while it is open. ---- */
(function(){
  "use strict";
  var pop = document.querySelector("[data-sph-giftpop]");
  if (!pop) return;
  var KEY = "sph-giftpop-seen";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var card = pop.querySelector(".gpop-card");
  var cards = Array.prototype.slice.call(pop.querySelectorAll(".gc"));
  var gifts = Array.prototype.slice.call(pop.querySelectorAll("template[data-gift]"));
  var status = pop.querySelector(".gifts-status");
  var sum = pop.querySelector(".gsum"), sumH = sum && sum.querySelector("h3");
  var show = pop.querySelector(".gifts-show");
  var form = pop.querySelector(".gpop-form"), input = form && form.querySelector("input[type=email]");
  var submit = form && form.querySelector("button[type=submit]"), msg = pop.querySelector(".gpop-msg"), okMsg = pop.querySelector(".gpop-ok");
  var PICKS = 3, picks = 0, done = false, isOpen = false, unlocked = false, sending = false, lastFocus = null;
  var root = document.documentElement;
  /* ---- shared 9-card state (BOTH pop-ups: sp-join-giftpop + sp-home-giftpop; keep the two copies identical) ----
     localStorage "sp_gifts" = {state:"done"|"dismissed", picks:[card indexes], ts} + a mirror cookie "sp_gifts"
     (path=/, 180 days, SameSite=Lax) for Safari ITP / private mode. done = never auto-open again on this device;
     dismissed = no auto-open for 7 days. Everything is wrapped: with storage blocked the page still works. */
  var GKEY = "sp_gifts", GDAYS = 7;
  function gParse(raw){ try { var o = JSON.parse(raw); return o && (o.state === "done" || o.state === "dismissed") ? o : null; } catch (err){ return null; } }
  function gRead(){
    var a = null, b = null;
    try { a = gParse(localStorage.getItem(GKEY)); } catch (err){}
    try { var m = document.cookie.match(/(?:^|;\s*)sp_gifts=([^;]*)/); if (m) b = gParse(decodeURIComponent(m[1])); } catch (err){}
    if (!a || !b) return a || b;
    if (a.state === "done") return a;
    if (b.state === "done") return b;
    return (+b.ts || 0) > (+a.ts || 0) ? b : a;
  }
  function gWrite(state, pickList){
    var cur = gRead();
    if (cur && cur.state === "done" && state !== "done") return;
    var v = JSON.stringify({ state: state, picks: pickList || [], ts: Date.now() });
    try { localStorage.setItem(GKEY, v); } catch (err){}
    try { document.cookie = GKEY + "=" + encodeURIComponent(v) + "; path=/; max-age=" + (180 * 86400) + "; SameSite=Lax" + (location.protocol === "https:" ? "; Secure" : ""); } catch (err){}
  }
  function gBlocked(){
    var o = gRead(); if (!o) return false;
    if (o.state === "done") return true;
    return Date.now() - (+o.ts || 0) < GDAYS * 86400000;
  }
  function gPicks(){ var out = []; cards.forEach(function(c, i){ if (c.getAttribute("aria-pressed") === "true") out.push(i); }); return out; }

  function setLocked(on){
    unlocked = !on;
    pop.classList.toggle("is-locked", on); pop.classList.toggle("is-unlocked", !on);
    cards.forEach(function(c){ if (on) c.setAttribute("aria-disabled", "true"); else c.removeAttribute("aria-disabled"); });
  }
  function turn(c, delay){
    if (c.getAttribute("aria-pressed") === "true") return null;
    var g = gifts[picks % gifts.length];
    var front = c.querySelector(".gc-front");
    while (front.firstChild) front.removeChild(front.firstChild);
    front.appendChild(g.content.cloneNode(true));
    var gf = g.style.getPropertyValue("--gf"); if (gf) front.style.setProperty("--gf", gf);
    c.setAttribute("aria-pressed", "true");
    c.setAttribute("aria-label", g.getAttribute("data-label"));
    picks++;
    if (delay && !reduce) setTimeout(function(){ c.classList.add("is-flipped"); }, delay); else c.classList.add("is-flipped");
    return g;
  }
  function finish(focusSummary){
    if (done) return;
    done = true;
    gWrite("done", gPicks());
    cards.forEach(function(c){
      if (c.getAttribute("aria-pressed") !== "true"){ c.classList.add("is-dim"); c.setAttribute("aria-disabled", "true"); c.tabIndex = -1; }
    });
    pop.classList.add("is-done");
    if (sum) sum.classList.add("is-on");
    if (status) status.textContent = pop.getAttribute("data-done") || "";
    setTimeout(function(){
      if (!isOpen || !sum) return;
      if (focusSummary && sumH) sumH.focus();
      var cr = card.getBoundingClientRect(), sr = sum.getBoundingClientRect();
      if (sr.bottom > cr.bottom || sr.top < cr.top) card.scrollTop += sr.top - cr.top - 16;
    }, reduce ? 0 : 900);
  }
  /* LOCKED-CARD NUDGE (2026-10-12, optimizer F5; the same answer the join pop-up has had since 2026-10-09): a tap on a
     face-down card before the email (or phone) step only focused a field, so nothing visibly happened. Now the field row
     shakes with a lime ring, a one-line hint shows under it (section settings "Locked card hint") and the field is focused. */
  var nudgeT = 0;
  function nudge(){
    var phone = pop.classList.contains("is-phone");
    var f = phone ? pform : form, fi = phone ? pinput : input, m = phone ? pmsg : msg;
    if (!f || !fi) return;
    var hint = pop.getAttribute(phone ? "data-hint-phone" : "data-hint") || "";
    if (m && hint){ m.textContent = hint; f.classList.add("has-hint"); }
    f.classList.remove("is-nudge"); void f.offsetWidth; f.classList.add("is-nudge");
    clearTimeout(nudgeT); nudgeT = setTimeout(function(){ f.classList.remove("is-nudge"); }, 700);
    var cr = card.getBoundingClientRect(), fr = f.getBoundingClientRect();
    if (fr.top < cr.top + 8) card.scrollTop += fr.top - cr.top - 16;
    try { if (document.activeElement === fi) fi.blur(); fi.focus({ preventScroll: true }); } catch (err){ try { fi.focus(); } catch (err2){} }
  }
  function clearHint(f, m){
    if (!f || !f.classList.contains("has-hint")) return;
    f.classList.remove("has-hint");
    if (m && (m.textContent === pop.getAttribute("data-hint") || m.textContent === pop.getAttribute("data-hint-phone"))) m.textContent = "";
  }
  if (form && input){ input.addEventListener("input", function(){ clearHint(form, msg); }); form.addEventListener("submit", function(){ clearHint(form, msg); }, true); }
  cards.forEach(function(c){
    c.addEventListener("click", function(){
      if (!unlocked){ nudge(); return; }
      if (done) return;
      var g = turn(c, 0); if (!g) return;
      if (status) status.textContent = g.getAttribute("data-label");
      if (picks >= PICKS) finish(document.activeElement === c);
    });
  });
  if (show) show.addEventListener("click", function(){
    if (!unlocked || done) return;
    var k = 0;
    cards.forEach(function(c){ if (picks < PICKS && turn(c, k * 120)) k++; });
    finish(true);
  });

  /* email -> Klaviyo client subscriptions API */
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  if (form) form.addEventListener("submit", function(e){
    e.preventDefault();
    if (sending) return;
    var em = (input.value || "").trim();
    if (!EMAIL.test(em)){ msg.textContent = pop.getAttribute("data-bad") || ""; input.focus(); return; }
    msg.textContent = ""; sending = true; submit.disabled = true;
    var body = { data: { type: "subscription", attributes: {
        custom_source: pop.getAttribute("data-source") || "SP homepage 9-card pop-up",
        profile: { data: { type: "profile", attributes: { email: em, subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } } } } },
      relationships: { list: { data: { type: "list", id: pop.getAttribute("data-list") } } } } };
    fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(pop.getAttribute("data-company")), {
      method: "POST", headers: { "Content-Type": "application/vnd.api+json", "Accept": "application/vnd.api+json", "revision": "2025-04-15" },
      body: JSON.stringify(body)
    }).then(function(r){
      if (!r.ok) throw new Error("klaviyo " + r.status);
      sending = false; afterEmail(em);
    }).catch(function(){
      sending = false; submit.disabled = false;
      msg.textContent = pop.getAttribute("data-err") || "";
    });
  });

  /* phone step (2026-10-05, optional for the visitor): shown once the email is accepted; "Claim my gift" saves the number to
     the same Klaviyo profile + list with SMS marketing consent, the skip link saves nothing; either one unlocks the cards. */
  var pform = pop.querySelector(".gpop-phone"), pinput = pform && pform.querySelector("input[type=tel]");
  var psubmit = pform && pform.querySelector("button[type=submit]"), pmsg = pform && pform.querySelector(".gpop-pmsg");
  var pskip = pform && pform.querySelector("[data-gpop-nophone]"), psending = false, gotEmail = "";
  function afterEmail(em){
    gotEmail = em;
    if (!pform){ setLocked(false); if (okMsg) okMsg.focus(); return; }
    pop.classList.add("is-phone");
    setTimeout(function(){ try { pinput.focus({ preventScroll: true }); } catch (err){ pinput.focus(); } }, 30);
  }
  function afterPhone(cls){
    pop.classList.add(cls); pop.classList.remove("is-phone"); setLocked(false);
    if (okMsg) okMsg.focus();
  }
  if (pform){
    pinput.addEventListener("input", function(){ clearHint(pform, pmsg); }); pform.addEventListener("submit", function(){ clearHint(pform, pmsg); }, true);
    pskip.addEventListener("click", function(){ afterPhone("is-nophone"); });
    pform.addEventListener("submit", function(e){
      e.preventDefault();
      if (psending) return;
      var d = (pinput.value || "").replace(/\D/g, "");
      if (d.length === 11 && d.charAt(0) === "1") d = d.slice(1);
      if (d.length !== 10 || d.charAt(0) < "2" || d.charAt(3) < "2"){ pmsg.textContent = pform.getAttribute("data-bad") || ""; pinput.focus(); return; }
      pmsg.textContent = ""; psending = true; psubmit.disabled = true;
      var body = { data: { type: "subscription", attributes: {
          custom_source: (pop.getAttribute("data-source") || "SP 9-card pop-up") + " (phone)",
          profile: { data: { type: "profile", attributes: { email: gotEmail, phone_number: "+1" + d,
            properties: { sp_phone_from: "9-card pop-up" }, subscriptions: { sms: { marketing: { consent: "SUBSCRIBED" } } } } } } },
        relationships: { list: { data: { type: "list", id: pop.getAttribute("data-list") } } } } };
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(pop.getAttribute("data-company")), {
        method: "POST", headers: { "Content-Type": "application/vnd.api+json", "Accept": "application/vnd.api+json", "revision": "2025-04-15" },
        body: JSON.stringify(body)
      }).then(function(r){
        psending = false;
        if (!r.ok) throw new Error("klaviyo " + r.status);
        afterPhone("is-phoned");
      }).catch(function(){
        psending = false; psubmit.disabled = false;
        pmsg.textContent = pop.getAttribute("data-err") || "";
      });
    });
  }

  function focusables(){
    return Array.prototype.slice.call(card.querySelectorAll("button, a[href], input, [tabindex]:not([tabindex='-1'])"))
      .filter(function(el){ return !el.disabled && el.tabIndex !== -1 && el.getClientRects().length && getComputedStyle(el).visibility !== "hidden"; });
  }
  function onKey(e){
    if (!isOpen) return;
    if (e.key === "Escape" || e.key === "Esc"){ e.preventDefault(); close(); return; }
    if (e.key !== "Tab") return;
    var f = focusables(); if (!f.length){ e.preventDefault(); card.focus(); return; }
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || !card.contains(a))){ e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !card.contains(a))){ e.preventDefault(); first.focus(); }
  }
  var timer = null, onScroll = null;
  function disarm(){ if (timer) clearTimeout(timer); timer = null; if (onScroll) window.removeEventListener("scroll", onScroll); onScroll = null; }
  function open(){
    if (isOpen) return;
    disarm();
    isOpen = true; lastFocus = document.activeElement;
    try { sessionStorage.setItem(KEY, "1"); } catch (err){}
    root.classList.add("sph-gpop-open");
    pop.classList.add("is-open");
    document.addEventListener("keydown", onKey, true);
    setTimeout(function(){ var t = unlocked ? cards[0] : (input || card); try { t.focus({ preventScroll: true }); } catch (err){ t.focus(); } }, 30);
  }
  function close(){
    if (!isOpen) return;
    isOpen = false;
    if (!done) gWrite("dismissed", gPicks());
    pop.classList.remove("is-open");
    root.classList.remove("sph-gpop-open");
    document.removeEventListener("keydown", onKey, true);
    if (lastFocus && lastFocus.focus && lastFocus !== document.body){ try { lastFocus.focus({ preventScroll: true }); } catch (err){} }
  }
  Array.prototype.forEach.call(pop.querySelectorAll("[data-gpop-close]"), function(b){ b.addEventListener("click", close); });
  pop.addEventListener("click", function(e){ if (e.target === pop) close(); });
  window.sphGiftpop = { open: open, close: close };

  /* trigger: after N seconds or N% scroll, once per session; ?nopop=1 and /pages/join never */
  var skip = /[?&]nopop=1(&|$)/.test(location.search) || /^\/pages\/join/.test(location.pathname);
  var seen = false;
  try { seen = sessionStorage.getItem(KEY) === "1"; } catch (err){}
  if (skip || seen || gBlocked()) return;
  var delay = Math.max(1, parseFloat(pop.getAttribute("data-delay")) || 6) * 1000;
  var pct = (parseFloat(pop.getAttribute("data-scroll")) || 40) / 100;
  function fire(){ disarm(); open(); }
  timer = setTimeout(fire, delay);
  onScroll = function(){
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && window.pageYOffset / h >= pct) fire();
  };
  window.addEventListener("scroll", onScroll, { passive: true });
})();
